export const faqData = [
  {
    question: "home.faq_1_question",
    answer: "home.faq_1_res",
    open: true,
  },
  {
    question: "home.faq_2_question",
    answer: "home.faq_2_res",
    open: false,
  },
  {
    question: "home.faq_3_question",
    answer: "home.faq_3_res",
    open: false,
  },
  {
    question: "home.faq_4_question",
    answer: "home.faq_4_res",
    open: false,
  },
];
